module.exports = __webpack_public_path__ + "css/datum-loader.css";


//////////////////
// WEBPACK FOOTER
// ./src/datum-loader.css
// module id = 62
// module chunks = 0